import { Component, ElementRef, HostListener, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

import { HeaderService, DataService, BranchEndpointService, GlobalVariables } from '../common/index';
import packageInfo from '../../../package.json';
const { version } = packageInfo;

declare var swal: any;

@Component({
  selector: 'main-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  showLogout: boolean = false;
  loggedIn;
  qtimeAppPrinterUrl: string = GlobalVariables.QTIME_APP_PRINTER_URL;
  version: string = version;
  menuOpen = false;
  @ViewChild('menuToggle') menuToggle?: ElementRef<HTMLButtonElement>;
  constructor(
    private host: ElementRef<HTMLElement>,
    private router: Router,
    private headerService: HeaderService,
    private dataService: DataService,
    public branchEndpointService: BranchEndpointService
  ) {
    this.validateLogin();
  }

  validateLogin() {
    this.loggedIn = this.dataService.sessionData();

    if (this.loggedIn) {
      this.showLogout = true;
    }
  }

  ngOnInit() {
    this.headerService.showNavBarEmitter.subscribe((data) => {
      if (data !== null) {
        this.showLogout = data;
      }
    });
  }

  @HostListener('document:click', ['$event'])
  closeMenuOnOutsideClick(event: MouseEvent) {
    if (!this.host.nativeElement.contains(event.target as Node)) this.menuOpen = false;
  }

  @HostListener('document:keydown.escape')
  closeMenuOnEscape() {
    if (!this.menuOpen) return;
    this.menuOpen = false;
    this.menuToggle?.nativeElement.focus();
  }

  @HostListener('window:resize')
  closeMenuOnWideScreen() {
    if (window.innerWidth > 880) this.menuOpen = false;
  }

  logoutSession() {
    swal({
      title: 'Sign out?',
      text: 'You will be logged out of the system.',
      type: 'warning',
      allowOutsideClick: true,
      showCancelButton: true,
      allowEscapeKey: false,
      reverseButtons: true,
      focusCancel: true,
      confirmButtonColor: '#009D4F',
      confirmButtonText: 'Sign out',
      cancelButtonColor: '#E94B4B',
      cancelButtonText: 'Cancel',
    })
      .then(() => {
        this.router.navigate(['/logout']);
      })
      .catch((_) => {
        return;
      });
  }
}
